import React from 'react';

function PricingCTA() {
  return (
    <section style={s.ctaSection}>
      <div style={s.ctaInner}>
        <h2 style={s.ctaHeadline}>Get a quote.</h2>
        <p style={s.ctaSub}>
          All prices on this page are for guidance. Tell us about your business and what you're looking for. We'll come back with a tailored quote as soon as we can.
        </p>
        <a href="/contact" className="contact-btn" style={s.ctaBtn}>
          Get in touch
        </a>
        <p style={s.freeNote}>No charge to get a quote. We don't charge for conversations or estimates.</p>
      </div>
    </section>
  );
}

const s = {
  ctaSection: {
    padding: '80px 24px',
    background: '#1c1c1e',
    textAlign: 'center',
  },
  ctaInner: { maxWidth: 560, margin: '0 auto' },
  ctaHeadline: {
    fontSize: 'clamp(1.8rem, 5vw, 2.8rem)',
    fontWeight: 800,
    letterSpacing: '-0.03em',
    color: '#f9f9f7',
    margin: '0 0 16px',
  },
  ctaSub: {
    fontSize: '1rem',
    color: '#9ca3af',
    lineHeight: 1.7,
    margin: '0 0 36px',
  },
  freeNote: {
    marginTop: 20,
    fontSize: '0.8rem',
    color: '#4a4f66',
    lineHeight: 1.6,
  },
  ctaBtn: {
    display: 'inline-block',
    background: '#f9f9f7',
    color: '#1c1c1e',
    textDecoration: 'none',
    fontSize: '0.9rem',
    fontWeight: 700,
    padding: '13px 28px',
    borderRadius: 10,
    letterSpacing: '0.01em',
    transition: 'opacity 0.15s',
  },
};

export default PricingCTA;
